<template>
  <div class="lee-tag-group">
    <transition-group class="lee-tags" name="list" tag="div">
      <slot></slot>
    </transition-group>
    <div class="editinput" key="edit" v-if="editable">
      <span key="edits" v-if="!edit" @click="edit=true">+ 新标签</span>
      <input v-focus key="editip" v-else type="text" ref="ipt" name="" v-model="newtag" @blur="addtag">
    </div>
    <lee-alert key="alert" v-if="err" title="标签重复" type="danger" show-icon></lee-alert>
  </div>
</template>
<script>
export default {
    name: 'LeeTagGroup',
    data() {
        return {
            tags: [],
            newtag: '',
            edit: false,
            err: false
        }
    },
    provide() {
        return {
            taggroup: this
        };
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus()
            }
        }
    },
    watch: {
        tag: {
            immediate: true,
            handler(value) {
                this.tags = value
            }
        }
    },
    mounted() {
        this.keyupEnter()
    },
    methods: {
        keyupEnter() {
            document.onkeydown = (e) => {
                let ipt = this.$refs.ipt
                if (e.keyCode === 13 && e.target === ipt) {
                    this.addtag()
                }
            }
        },
        addtag() {
            this.edit = false
            var newtag = this.newtag.replace(/\s*/g, "");
            if (newtag.length > 0) {
                var fi = this.tags.filter(function (el) {
                    return el.t.indexOf(newtag) > -1;
                });
                if (fi.length < 1) {
                    this.tags.push({t: newtag})
                } else {
                    this.err = true
                    setTimeout(() => {
                        this.err = false
                    }, 2000)
                }

            }
            this.newtag = ''

        }
    },
    props: {
        tag: {
            type: Array,
            default() {
                return []
            }
        },
        closeable: {
            type: Boolean,
            default: false //默认default
        },
        editable: {
            type: Boolean,
            default: false //默认default
        }
    }
};
</script>
<style scoped>
.lee-tags {
  display: flex;
  flex-wrap: wrap;
}

.lee-tag-group {
  display: flex;
  flex-wrap: wrap;
}

.lee-tag-group .editinput {
  height: 32px;
  margin-left: 10px;
  display: flex;
  flex-wrap: wrap;
}

.lee-tag-group .editinput span {
  font-size: 12px;
  line-height: 30px;
  padding: 0 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
  transition: all .5s
}

.lee-tag-group .editinput span:hover {
  color: rgb(103, 194, 58);
  background: rgba(103, 194, 58, 0.1);
  border: 1px solid rgba(103, 194, 58, 0.4);
}

.lee-tag-group .editinput input {
  width: 81px;
  border: 1px solid rgba(103, 194, 58, 1);
  border-radius: 4px;
  outline: none;
  box-sizing: border-box;
  padding: 0 10px;
}

.lee-tag-group .lee-alert {
  margin: 0;
  height: 32px;
  margin-left: 15px;
  transition: all .4s;
}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeTagGroup.vue